import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export function Card({ children, className = "", hover = false }: CardProps) {
  return (
    <div
      className={`border border-gray-200 rounded-lg overflow-hidden ${
        hover ? "hover:border-blue-300 transition-colors" : ""
      } ${className}`}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  className?: string;
}

export function CardHeader({
  icon,
  title,
  subtitle,
  className = "",
}: CardHeaderProps) {
  return (
    <div
      className={`bg-gray-50 border-b border-gray-200 px-4 sm:px-6 py-4 flex items-center gap-3 ${className}`}
    >
      {icon && <div className="text-gray-600 flex-shrink-0">{icon}</div>}
      <div className="min-w-0">
        <h2 className="text-gray-900 text-base sm:text-xl">{title}</h2>
        {subtitle && (
          <p className="text-sm text-gray-600 break-words">{subtitle}</p>
        )}
      </div>
    </div>
  );
}

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

export function CardContent({ children, className = "" }: CardContentProps) {
  return <div className={`p-4 sm:p-6 ${className}`}>{children}</div>;
}
